const getSuggestions = (text) => {
  const apiEndpointPrefix = process.env.RAZZLE_ENDPOINT_API_GATEWAY_URL;
  return fetch(`${apiEndpointPrefix}/suggestions?words=${text}&size=25`)
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      return { data: data };
    });
};

export default getSuggestions;
